import React, { useState } from "react";
import { createVendorApi } from "../Apis/apis";

const sates = {
  company_name: "",
  address: "",
  state: "",
  city: "",
  gst: "",
  pan: "",
  email: "",
  phone: "",
};

const NewVendor = ({ setVendor, path, fetchPost }) => {
  const [posts, setPosts] = useState(sates);
  const createVendor = async (e) => {
    e.preventDefault();

    // Check if all fields in update are filled
    const areAllFieldsFilled = Object.values(posts).every(
      (value) => value !== ""
    ); 

    if (!areAllFieldsFilled) {
      alert("Please fill in all fields before submitting.");
      return;
    }
    const data = await createVendorApi(path, posts);

    if (data.message === "Your data Added") {
      setPosts();
      setVendor(true);
      fetchPost();
    } else {
      alert("something wrong");
    }
  };
  const handleChange = async (e) => {
    const { name, value } = e.target;
    setPosts({ ...posts, [name]: value });
  };

  return (
    <div>
      <form onSubmit={createVendor}>
        <div className="flex">
          <div>
            <div
              className="d-flex 
            "
            >
              <button
                className="edit-btn float-right border-0 mb-2"
                onClick={(e) => setVendor(true)}
                style={{ width: "2rem" }}
              >
                Back
              </button>
              {/* <h4 className="m-3 text-center">Vendor Details</h4> */}
            </div>

            <div className="row">
              <div className="col-6 ">
                <label className="ms-2">Company Name</label>
                <input
                  name="company_name"
                  className=" form-control"
                  required
                  type="text"
                  onChange={handleChange}
                />
                <label className="ms-2">Address</label>
                <input
                  className=" form-control"
                  required
                  name="address"
                  type="text"
                  onChange={handleChange}
                />
                <label className="ms-2">State</label>
                <input
                  className=" form-control"
                  required
                  name="state"
                  type="text"
                  onChange={handleChange}
                />
                <label className="ms-2"> city</label>
                <input
                  className=" form-control"
                  required
                  name="city"
                  type="text"
                  onChange={handleChange}
                />
              </div>

              <div className="col-6 ps-3">
                <label className="ms-2">GST No.</label>
                <input
                  className=" form-control"
                  required
                  name="gst"
                  type="text"
                  onChange={handleChange}
                />
                <label className="ms-2">PAN No.</label>
                <input
                  className=" form-control"
                  required
                  name="pan"
                  type="text"
                  onChange={handleChange}
                />

                <label className="ms-2">Email</label>
                <input
                  className=" form-control ms-2 mt-2 mb-2"
                  required
                  name="email"
                  type="email"
                  onChange={handleChange}
                />
                <label className="ms-2 mt-2">Phone</label>
                <input
                  className=" form-control ms-2 mt-2 "
                  required
                  name="phone"
                  type="number"
                  onChange={handleChange}
                />
              </div>
            </div>
          </div>
        </div>
        <div className="d-flex justify-content-center">
          <input type="submit" value="Save" className="m-2 w-50" />
        </div>
      </form>
    </div>
  );
};

export default NewVendor;
